const FEATURE_ENABLED_ENV_NAME = 'SANITY_CLI_SCHEMA_STORE_ENABLED'

export const SCHEMA_STORE_FEATURE_ENABLED = process.env[FEATURE_ENABLED_ENV_NAME] === 'true'
